<div class="toolbar" *ngIf="!toolbarHidden" [ngClass]="{'mini-mode': isMiniMode}">
  <div class="top-toolbar">
    <div class="logo-wrapper">
      <img height="46px;"
      [attr.width]="isMiniMode ? '46px' : '180px'" 
      [attr.src]="isMiniMode ? logoUrl : logoUrl" class="img-fluid cp" (click)="redirectToOvewView()"/>
    </div>
    <button *ngFor="let nav of navigationConstants" mat-button class="nav-button" routerLink="{{nav.route}}" routerLinkActive="activeLink">
      <div class="button-wrapper">
        <div class="svg-icon-wrapper">
          <div class="{{nav.icon}}" [ngClass]="{'svg-icon': nav.icon !== 'fiWeIcon'}"></div>
        </div>
        <span *ngIf="!isMiniMode" style="color: #797A81;" class="majorant">{{capitalizeFirstLetter(nav.route) | translate}}</span>
      </div>
    </button>

    <div *ngIf="numberOfDaysLeftForTrial && !isMiniMode"
      (click)="openTrialContactDialog(false)"
      class="free-trial-container"
      [ngClass]="{
        redt: numberOfDaysLeftForTrial < 8,
        blue: numberOfDaysLeftForTrial >= 8
      }"
    >
      <img
        *ngIf="numberOfDaysLeftForTrial > 7"
        height="20"
        width="20"
        class="schedule-icon"
        src="assets/icons/schedule.svg"
        alt="ee"
      />
      <img
        *ngIf="numberOfDaysLeftForTrial < 8"
        height="20"
        width="20"
        class="schedule-icon"
        src="assets/icons/warning.svg"
        alt="ee"
      />
      <div class="free-trial-holder">
        <div class="title">
          <div *ngIf="numberOfDaysLeftForTrial > 0" class="title-font">
            Your free trial expires in {{ numberOfDaysLeftForTrial }} days!
          </div>
          <div *ngIf="numberOfDaysLeftForTrial < 1" class="title-font">
            Your free trial has ended
          </div>
        </div>
        <div class="content">
          <div
            *ngIf="dailiyScanLimit > 100"
            class="content-font used-daily-limit"
          >
          You have used your daily limit! For a higher allowance, please contact us.
          </div>
          <span *ngIf="numberOfDaysLeftForTrial > 0" class="content-font"
            >Enjoy the free trial, if you want unlimited use, contact us.</span
          >
          <span *ngIf="numberOfDaysLeftForTrial < 1" class="content-font"
            >Free trial ended, if you want unlimited use, contact us.</span
          >
        </div>
      </div>
    </div>
    <button (click)="logOut()" style="margin-top:auto;" mat-button class="nav-button">
      <div class="button-wrapper">
        <mat-icon [ngStyle]="{'color':'#797a81'}">logout</mat-icon>
        <span *ngIf="!isMiniMode" class="majorant grey">Log out</span>
      </div>
    </button>
  </div>
  <button class="toggle-button" (click)="toggleSidebar()" matTooltip="{{isMiniMode ? 'Expand sidebar' : 'Collapse sidebar'}}" matTooltipPosition="right">
    <mat-icon>{{isMiniMode ? 'chevron_right' : 'chevron_left'}}</mat-icon>
  </button>
</div>
